module.exports = __webpack_public_path__ + "img/two.e1434b8f.png";